import { Link } from 'react-router-dom';
import { Mail, Phone, Globe } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[var(--bg-secondary)] border-t border-[var(--border-light)] mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div>
            <h3 className="heading-3 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              MAGNIFICENT DIAMOND
            </h3>
            <p className="body-small mb-4">
              Preferred Partner of Wholesalers, Jewellers and Retailers for Lab-Grown Diamonds.
            </p>
            <p className="body-small text-[var(--accent-green-medium)] font-semibold">
              REAL • PURE • BETTER
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="body-small hover:text-[var(--accent-green-medium)] transition-all">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="body-small hover:text-[var(--accent-green-medium)] transition-all">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" className="body-small hover:text-[var(--accent-green-medium)] transition-all">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/contact" className="body-small hover:text-[var(--accent-green-medium)] transition-all">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h4 className="heading-3 mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Mail size={18} className="mt-1 text-[var(--accent-green-medium)]" />
                <span className="body-small">hello@magnificent.diamonds</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={18} className="mt-1 text-[var(--accent-green-medium)]" />
                <span className="body-small">+1 469 297-2933</span>
              </li>
              <li className="flex items-start gap-2">
                <Globe size={18} className="mt-1 text-[var(--accent-green-medium)]" />
                <span className="body-small">magnificent.diamonds</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[var(--border-light)] mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="body-small text-[var(--text-light)]">
              © {new Date().getFullYear()} Magnificent Diamond. All rights reserved.
            </p>
            <p className="body-small text-[var(--text-light)]">
              Preferred Partner of Wholesalers, Jewellers & Retailers
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
